module.exports = __webpack_public_path__ + "img/transformer-oil-tanker.933d0841.png";